import { createTheme } from '@mui/material/styles';
import { alpha } from "@mui/material/styles";

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#1e90ff',
        hover: '#47a3ff'
      }
    }
  }
);

export const m2dTheme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    MuiAvatarGroup: {
      styleOverrides: {
        root: {
          // background: 'black'
        },
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          height: 25,
          width: 25,
          fontSize: 15,
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.24)',
          borderRadius: Number(theme.shape.borderRadius) * 2,
          position: "relative",
          zIndex: 0,
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 2, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
        },
      },
    },    
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          paddingBottom: theme.spacing(4),
        },
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.05),
          },
          head: {
            color: theme.palette.text.secondary,
            fontWeight: 500
          },
        }
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          fontWeight: 500
        },
        body: {
          color: theme.palette.text.secondary,
          fontWeight: 500
        }
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
          backgroundColor: theme.palette.grey[800],
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            "& svg": { color: theme.palette.text.disabled },
          },
        },
        input: {
          "&::placeholder": {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        },
        contained: {
          backgroundColor: theme.palette.primary.main,
          boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.2)",
          "&:hover": {
            backgroundColor: theme.palette.primary.hover,
            boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main
        }
      }
    },
    MuiSwitch: {
      colorPrimary: theme.palette.primary.main,
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: theme.palette.primary.main
          }
        }
      }
    },
    MuiTextField: {
      colorPrimary: theme.palette.primary.main,
    }
  },
});